import type { ElementDto } from "@repo/api/overlays";
import type { Point } from "@/features/Editor/Canvas/canvas-geometry";

const DUPLICATE_OFFSET = 20;

export function createElementCopy(
  element: ElementDto,
  position: Point,
): ElementDto {
  return {
    ...structuredClone(element),
    externalId: crypto.randomUUID(),
    position: { type: "ABSOLUTE", ...position },
  };
}

// Puts the copies in front of the scene's elements, offset by 20px.
export function getDuplicatedElements(
  elements: ElementDto[],
  selectedIds: string[],
) {
  const copies = elements
    .filter((element) => selectedIds.includes(element.externalId))
    .map((element) =>
      createElementCopy(element, {
        x: element.position.x + DUPLICATE_OFFSET,
        y: element.position.y + DUPLICATE_OFFSET,
      }),
    );

  return { elements: [...copies, ...elements], copies };
}
